<template>
  <h1
      class="titleClass"
      :class="$vuetify.theme.dark ? 'title_dark' : 'title_light'"
      style="padding-top: 30px"
  >
    <v-icon
        v-if="icon.length > 0"
        :class="$vuetify.theme.dark ? 'title_dark' : 'title_light'"
        style="font-size: 23px"
        left
    >{{ icon }}
    </v-icon
    >
    {{ title }}
  </h1>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    }
  }
}
</script>

<style lang="scss" scoped>
.titleClass {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.titleClass:before,
.titleClass:after {
  content: "";
  border-top: 2px solid #47bd96;
  margin: 0 20px 0 0;
  flex: 1 0 20px;
}

.titleClass:after {
  margin: 0 0 0 20px;
}

.titleClass {
  color: #ffffff;
  font-family: Dosis, sans-serif;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2.11px;
  text-transform: uppercase;
}

.title_dark {
  color: #47bd96 !important;
}

.title_light {
  color: #1c6e59 !important;
}
</style>